import { render } from "./WhitepaperDownload.vue?vue&type=template&id=61dc798b&scoped=true"
import script from "./WhitepaperDownload.vue?vue&type=script&lang=js"
export * from "./WhitepaperDownload.vue?vue&type=script&lang=js"

import "./WhitepaperDownload.vue?vue&type=style&index=0&id=61dc798b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61dc798b"]])

export default __exports__